/**
 * PWA service-worker registration with an explicit update prompt. Registration
 * is manual (vite-plugin-pwa injectRegister:null) so we can surface a
 * "new version" toast instead of silently reloading mid-edit.
 */
import { registerSW } from "virtual:pwa-register";

export interface PwaHandlers {
  onNeedRefresh?: () => void;
  onOfflineReady?: () => void;
}

export interface PwaController {
  /** Apply the waiting update and reload. */
  update: () => void;
}

export function setupPWA(handlers: PwaHandlers = {}): PwaController {
  const updateSW = registerSW({
    immediate: true,
    onNeedRefresh() {
      handlers.onNeedRefresh?.();
    },
    onOfflineReady() {
      handlers.onOfflineReady?.();
    },
  });
  return {
    update: () => void updateSW(true),
  };
}
